{
  "eyebrow": "Вътре сте",
  "title": "Добре дошли в Done-it, {{company}}.",
  "sub": "Вашият 30-дневен пробен период за {{plan}} е активен. Три следващи стъпки.",
  "next1": {
    "title": "Изтеглете мобилното приложение",
    "desc": "Изпратете линка за инсталация на екипа си по SMS или имейл.",
    "cta": "Изпрати линк за покана"
  },
  "next2": {
    "title": "Поканете екипа си",
    "desc": "Импортирайте служители групово от CSV или ги добавете един по един.",
    "cta": "Отвори админа"
  },
  "next3": {
    "title": "Гледайте 4-минутна обиколка",
    "desc": "Вижте как да настроите първия си проект и локациите.",
    "cta": "Гледай видео"
  },
  "cta": "Към таблото",
  "receipt": "Разписка и приветстващ имейл пътуват към {{email}}.",
  "fallbacks": {
    "company": "вашата компания",
    "plan": "вашия план",
    "inbox": "вашата пощенска кутия"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Вашият акаунт {{plan}} е активен — безплатен завинаги. Три неща за следващи стъпки."
}
